Slslider = {
	init: function(){

	}
}